"use client";

import { Instagram, Music2, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-32 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-20 bg-foreground/10 animate-pulse" />
        <div className="h-5 w-28 bg-foreground/10 animate-pulse" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-base uppercase tracking-wide text-foreground hover:text-primary hover:underline underline-offset-[6px] transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const playbookLinks = [{
  label: "سوالات متداول",
  to: "#"
}, {
  label: "مشاوره فوری",
  to: "/TalkWithUsPage"
}, {
  label: "همکاری",
  to: "#"
}, {
  label: "قوانین",
  to: "#"
}];
const tickerWords = ["مدرن", "خلاقانه", "شخصی‌سازی", "معماری", "کیفیت", "مدرن", "خلاقانه", "شخصی‌سازی", "معماری", "کیفیت"];
const socialLinks = [{
  Icon: Instagram,
  label: "Instagram",
  to: "#"
}, {
  Icon: Music2,
  label: "TikTok",
  to: "#"
}, {
  Icon: Youtube,
  label: "YouTube",
  to: "#"
}];
const legalLinks = [{
  label: "حریم خصوصی",
  to: "#"
}, {
  label: "شرایط",
  to: "#"
}, {
  label: "دسترسی",
  to: "#"
}];
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="1274" id="پانویس-سایت" className="relative bg-background text-foreground overflow-hidden" style={{
    clipPath: "polygon(0 4%, 100% 0, 100% 100%, 0 100%)"
  }}>
      {}
      <div className="absolute top-0 left-0 w-2 h-2 bg-primary rounded-lg z-10" style={{
      transform: "translate(0, 2vw)"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative pt-32 pb-12 px-6 md:px-12 lg:px-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex items-center gap-3 mb-12 max-w-[1400px] mx-auto">
          <div className="w-6 h-px bg-primary" />
          <span className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60">
            استودیو معماری آرتین
          </span>
        </div>

        {}
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-16">
          {}
          <div className="md:col-span-4 flex flex-col gap-5">
            <Link to="/" aria-label="خانه آرتین">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="font-default text-lg md:text-xl text-foreground/80 leading-relaxed max-w-sm">
              طراحی فضاهای مدرن با رویکردی شخصی‌سازی شده برای زندگی بهتر.
            </p>
            <span className="font-mono text-xs tracking-[0.15em] uppercase text-foreground/60 mt-2">
              تهران / استودیو طراحی داخلی
            </span>
          </div>

          {}
          <div className="md:col-span-4 grid grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <h4 className="font-default text-sm uppercase tracking-[0.18em] text-foreground/60">
                استودیو
              </h4>
              <MenuProvider menu_id="35">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>
            <div className="flex flex-col gap-4">
              <h4 className="font-default text-sm uppercase tracking-[0.18em] text-foreground/60">
                منابع
              </h4>
              <ul className="flex flex-col gap-3">
                {playbookLinks.map((item, i) => <li data-index={i} key={item.label}>
                    <Link to={item.to} className="font-default text-base uppercase tracking-wide text-foreground hover:text-primary hover:underline underline-offset-[6px] transition-colors duration-200">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div className="md:col-span-2 flex flex-col gap-4">
            <h4 className="font-default text-sm uppercase tracking-[0.18em] text-foreground/60">
              تماس
            </h4>
            <div className="flex flex-col gap-2 font-default text-sm text-foreground/90">
              <Link to="mailto:info@arq-design.ir" className="hover:text-primary transition-colors break-all">
                info@arq-design.ir
              </Link>
              <Link to="tel:+982100000000" className="hover:text-primary transition-colors">
                ۰۲۱-۰۰۰۰۰۰۰۰
              </Link>
              <span className="font-mono text-xs tracking-[0.15em] uppercase text-foreground/60 mt-1">
                شنبه تا چهارشنبه
              </span>
            </div>
          </div>

          {}
          <div className="md:col-span-2 flex flex-col gap-4">
            <h4 className="font-default text-sm uppercase tracking-[0.18em] text-foreground/60">
              شبکه‌ها
            </h4>
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((item, i) => {
              const Icon = item.Icon;
              return <Link data-index={i} key={item.label} to={item.to} aria-label={item.label} className="w-10 h-10 border border-foreground/40 flex items-center justify-center text-foreground hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all duration-200">
                    <Icon className="w-4 h-4" strokeWidth={1.75} />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="relative w-full overflow-hidden border-y border-foreground/20 py-6 -mx-6 md:-mx-12 lg:-mx-16">
          <div className="flex gap-12 whitespace-nowrap" style={{
          animation: "ticker-scroll 40s linear infinite",
          width: "max-content"
        }}>
            {[...tickerWords, ...tickerWords].map((word, i) => <span data-index={i} key={i} className="font-default text-3xl md:text-5xl uppercase tracking-wide text-foreground/90 flex items-center gap-12">
                {word}
                <span className="text-primary">·</span>
              </span>)}
          </div>
        </div>

        {}
        <div className="max-w-[1400px] mx-auto pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <span className="font-mono text-xs tracking-[0.15em] uppercase text-foreground/60">
            © ۲۰۲۵ استودیو معماری آرتین
          </span>
          <ul className="flex flex-wrap gap-6">
            {legalLinks.map((item, i) => <li data-index={i} key={item.label}>
                <Link to={item.to} className="font-mono text-xs tracking-[0.15em] uppercase text-foreground/60 hover:text-primary transition-colors">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      <style>{`
        @keyframes ticker-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}